import React, { useState, useEffect } from "react"; // Add useEffect import
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Box,
  Typography,
} from "@mui/material";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import MyDatePicker from "../../widgets/MyDatePicker";
import { API_ENDPOINT } from "../../utils/constants";
import { getHeader } from "../../utils/util";
import { toast } from "react-toastify";
import useApiEp from "../../hooks/useApiEp";

const AddPlan = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    data: PlanData,
    isLoading: isPlanLoading,
    isError: isPlanError,
    error: Error,
  } = useApiEp(`/root/get-account/${id}`);

  const [formData, setFormData] = useState({
    planName: "",
    expiryDate: null,
  });
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Prefill form data when PlanData is available
  useEffect(() => {
    if (PlanData && PlanData.subscriptionPlan && PlanData.expiryDate) {
      setFormData({
        planName: PlanData.subscriptionPlan,
        expiryDate: PlanData.expiryDate, // Assumes expiryDate is in a format compatible with MyDatePicker
      });
    }
  }, [PlanData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateChange = (newValue) => {
    setFormData((prev) => ({
      ...prev,
      expiryDate: newValue ? newValue.format("YYYY-MM-DD") : null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsSubmitting(true);

    if (!formData.planName || !formData.expiryDate) {
      setError("Plan name and expiry date are required.");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch(`${API_ENDPOINT}/root/update-plan/${id}`, {
        method: "POST",
        ...getHeader(),
        body: JSON.stringify({
          planName: formData.planName,
          expiryDate: formData.expiryDate,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to submit plan");
      }
      toast.success("Updated successfully!");
      navigate(-1);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container sx={{ mt: 3 }} maxWidth="md">
      <BackBtn />
      <Container maxWidth="sm">
        <PageTitle>Add Plan</PageTitle>
        {isPlanLoading && <Typography>Loading...</Typography>}
        {isPlanError && (
          <Typography color="error">Error: {Error?.message}</Typography>
        )}
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <FormControl fullWidth size="small" required sx={{ mb: 2 }}>
            <InputLabel id="plan-select-label">Plan Name</InputLabel>
            <Select
              labelId="plan-select-label"
              name="planName"
              value={formData.planName}
              onChange={handleInputChange}
              label="Plan Name"
            >
              <MenuItem value="Plan1">Plan1</MenuItem>
              <MenuItem value="Plan2">Plan2</MenuItem>
              <MenuItem value="Plan3">Plan3</MenuItem>
              <MenuItem value="Plan4">Plan4</MenuItem>
            </Select>
          </FormControl>
          <MyDatePicker
            label="Expiry Date"
            value={formData.expiryDate}
            onChange={handleDateChange}
            required
            sx={{ mb: 2 }}
          />
          {error && (
            <Typography color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            sx={{ mt: 2 }}
          >
            {isSubmitting ? "Submitting..." : "Add Plan"}
          </Button>
        </Box>
      </Container>
    </Container>
  );
};

export default AddPlan;
